$('.tab-slick').slick({
    rows: 0,
    dots: false,
    arrows: false,
    slidesToShow: 11,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 535,
        settings: {
          slidesToShow: 3,
          swipeToSlide: true
        }
      }]
});
$('.to-tab-slick').slick({
    rows: 0,
    dots: false,
    arrows: false,
    slidesToShow: 11,
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 535,
        settings: {
          slidesToShow: 3,
          swipeToSlide: true
        }
      }]
});


  $('.new-tab-slick').slick({
    rows: 0,
    dots: false,
    arrows: false,
    slidesToShow: 11,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 735,
        settings: "unslick",
      }
    ]
});



  $('.offer-carousel-tab-slick').slick({
    rows: 0,
    asNavFor: '.offer-carousel-tab-content-slick',
    dots: false,
    arrows: false,
    slidesToShow: 6,
    variableWidth: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 3,
          swipeToSlide: true
        }
      }]
  });

  $('.offer-carousel-tab-content-slick').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.offer-carousel-tab-slick',
    prevArrow: "<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-next pull-right' aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          dots: true,
          arrows: false
      }
    }]
  });






  $('.carousel-description').slick({
    rows: 0,
    centerMode: true,
    centerPadding: '',
    slidesToShow: 3,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'  aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'  aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.carousel-offer-structure').slick({
    rows: 0,
    slidesToShow: 3,
    prevArrow: "<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-next pull-right' aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  $('.carousel-offer-plane').slick({
    rows: 0,
    slidesToShow: 3,
    prevArrow:"<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right' aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });


  $('.carousel-details-structure').slick({
    rows: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right' aria-label='right' ><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 1
        }
      }
    ]
  });



  $('.slider-for').slick({
    rows: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav',
    prevArrow:"<a class='carousel-control-prev' role='button' data-slide='prev' aria-label='left'><div class='border-icon'><i class='fa fa-angle-left'></i></div><span class='sr-only'>Previous</span></a>",
    nextArrow:"<a class='carousel-control-next' role='button' data-slide='next' aria-label='right'><div class='border-icon'><i class='fa fa-angle-right'></i></div><span class='sr-only'>Next</span></a>",
  });
  $('.slider-nav').slick({
    rows: 0,
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    arrows: false
  });


  $('#lightGallery').lightGallery({
    thumbnail: true,
    selector: '.item',
    fullScreen:false,
    animateThumb: false,
    showThumbByDefault: false,
    mode:"lg-fade",
    zoom:false,
    share:false,
    cssEasing:"cubic-bezier(.25, 0, .25, 1)"
    // selector: '#lightGallery .lslide',
    //selectWithin: '.slick-slide:not(.slick-cloned)'
  });



  $('.carousel-blog').slick({
    rows: 0,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1
        }
      }
    ]
  });







  $('.carousel-dna').slick({
    rows: 0,
    slidesToShow: 4,
    prevArrow: "<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-next pull-right' aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          arrows: false
        }
      },
      {
        breakpoint: 960,
        settings: "unslick"
      }
    ]
  });

  $('.carousel-dna-one-slide').slick({
    rows: 0,
    dots: true,
    slidesToShow: 1,
    prevArrow: "<button type='button' class='slick-prev pull-left' aria-label='left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow: "<button type='button' class='slick-next pull-right' aria-label='right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  });



  $('.carousel-fourslides-noarrow-dots-autoplay').slick({
	rows: 0,
	slidesToShow: 4,
	swipeToSlide: true,
	dots: true,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 1500,
	responsive: [
	  {
		breakpoint: 767,
		settings: {
		  slidesToShow: 1,
		}
	  }
	]
  });